import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Button } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { CardTitle } from '@delmonicos/shared-design-system-react/src/components/card-title/card-title';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Dialog } from '@delmonicos/shared-design-system-react/src/components/dialog/dialog';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { InputSkeleton } from '@delmonicos/shared-design-system-react/src/components/skeleton/input-skeleton';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { logout } from '@app/core/helper/logout';
import { useAppDispatch } from '@app/core/hooks';
import { useCpmsBoGetMeQuery } from '@app/core/service/cpms-bo-user-me.service';
import { UpdatePasswordForm } from '@app/feature/update-password/update-password.form';
import { useUpdatePassword } from '@app/feature/update-password/use-update-password';

import * as css from './profile.module.scss';

export const ProfileView = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: user } = useCpmsBoGetMeQuery();
  const [isDialogChangePasswordOpen, setIsDialogChangePasswordOpen] =
    useState(false);

  const { onSubmit, isLoading, isError } = useUpdatePassword({
    onSuccess: () => logout(dispatch, navigate),
  });

  return (
    <div className={css.profileContainer}>
      <Card gap={GapEnum.L} flex={1}>
        <CardTitle
          icon="info-circle"
          text={t('$.profile.personal-information.title')}
        />
        {user ? (
          <>
            <Stack
              gap={GapEnum.XL}
              justifyContent="space-between"
              className={css.personalInformationsContainer}>
              <TextInput
                label={t('delmonicos-shared-sdk.outputs-user.first-name')}
                readOnly
                value={user.firstName}
              />
              <TextInput
                label={t('delmonicos-shared-sdk.outputs-user.last-name')}
                readOnly
                value={user.lastName}
              />
            </Stack>
            {/* TODO: Refactor to comply with the new role system */}
            {/* <TextInput
                  label={t('profile.role')}
                  readOnly
                  value={t(`shared.role.${user.roleId}`)}
                /> */}
          </>
        ) : (
          <>
            <div className={css.personalInformationsContainer}>
              <InputSkeleton />
              <InputSkeleton />
            </div>
            <InputSkeleton />
          </>
        )}
      </Card>
      <Card gap={GapEnum.L} flex={1}>
        <CardTitle
          icon="user-circle"
          text={t('$.profile.account-parameters.title')}
          variant={AccentVariantEnum.Secondary}
        />
        <Stack gap={GapEnum.M} direction="column">
          {user ? (
            <>
              <TextInput
                label={t(
                  'delmonicos-shared-sdk.inputs-auth-login.email-address',
                )}
                readOnly
                value={user.emailAddress}
              />
              <TextInput
                label={t('delmonicos-shared-sdk.inputs-auth-login.password')}
                readOnly
                value="******"
                adornment={<Icon name="edit-05" />}
                adornmentOnClick={() => setIsDialogChangePasswordOpen(true)}
              />
            </>
          ) : (
            <>
              <InputSkeleton />
              <InputSkeleton />
            </>
          )}
        </Stack>
        <Card.Footer>
          <Button onClick={() => logout(dispatch, navigate)}>
            {t('$.profile.logout-button')}
          </Button>
        </Card.Footer>
      </Card>
      <Dialog
        open={isDialogChangePasswordOpen}
        onClose={() => setIsDialogChangePasswordOpen(false)}>
        <UpdatePasswordForm
          title={t('$.update-password.change-password.title')}
          caption=""
          isError={isError}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      </Dialog>
    </div>
  );
};
